import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from '../views/Login';
import Streaming from '../views/Streaming';
// Administracion
import Dev from '../views/Administracion/Dev';
import Dashboard from '../views/Administracion/Dashboard';
import ErrorPublica from '../views/ErrorPublica';

export default function Navigation() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/streaming' element={<Streaming />} />
          <Route path='/admin/dev' element={<Dev />} />
          <Route path='/admin/dashboard' element={<Dashboard />} />
          <Route path='*' element={<ErrorPublica />} />
        </Routes>
      </Router>
    </>
  );
}
